import http from '@/communication/AuthConnection'

export default ({ commit }, payload) => {
  return http.patch(`/v1/stock/item/${payload.id}`, payload)
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/stock/SaveItemEdition.js